import storefrontClient from "../client";

export const customerAccessTokenCreate = async (
  email: string,
  password: string,
) => {
  try {
    const response = await storefrontClient.request(
      `
      mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
       customerAccessTokenCreate(input: $input) {
         customerAccessToken {
           accessToken
         }
         customerUserErrors {
           message
         }
       }
     }
     `,
      {
        variables: {
          input: {
            email: email,
            password: password,
          },
        },
      },
    );

    return response?.data?.customerAccessTokenCreate;
  } catch (error) {
    console.error("Error creating cart:", error);
    throw error;
  }
};

export const customerAccessTokenCreateWithMultipass = async (
  multipassToken: string,
) => {
  try {
    const response = await storefrontClient.request(
      `
       mutation customerAccessTokenCreateWithMultipass($multipassToken: String!) {
        customerAccessTokenCreateWithMultipass(multipassToken: $multipassToken) {
          customerAccessToken {
            accessToken
          }
          customerUserErrors {
            message
          }
        }
      }
      `,
      {
        variables: {
          multipassToken,
        },
      },
    );

    return response?.data?.customerAccessTokenCreateWithMultipass;
  } catch (error) {
    console.error("Error creating cart:", error);
    throw error;
  }
};

export const customerActivateByUrl = async (
  activationUrl: string,
  password: string,
) => {
  try {
    const response = await storefrontClient.request(
      `
       mutation customerActivateByUrl($activationUrl: URL!, $password: String!) {
        customerActivateByUrl(activationUrl: $activationUrl, password: $password) {
          customer {
            id
          }
          customerUserErrors {
            code
            field
            message
          }
        }
      }
      `,
      {
        variables: {
          activationUrl,
          password,
        },
      },
    );

    return response?.data?.customerActivateByUrl;
  } catch (error) {
    console.error("Error activating customer by URL:", error);
    throw error;
  }
};
